import { SUBTYPES, TEAMS } from "@dl/declarations";
import { NavigateOptions } from "react-router-dom";

export const INPUT_VARIANTS = {
  none: "",

  white_text_dark_bg: "bg-cs-900 text-white",
  white_text_dark_orange_bg: "bg-dark-orange text-white",

  blue_text_white_bg: "bg-white text-cs-500",
  white_text_blue_bg: "bg-cs-500 text-white border-cs-600",

  gray_text_white_bg: "text-cs-800",
  deep_ocean_text_gray_bg: "text-cs-700 bg-cs-300 border-transparent",

  red_text_white_bg: "bg-white text-dark-orange",
  white_text_red_bg: "bg-dark-orange text-white",

  white_text_deep_ocean_bg: "bg-cs-900 text-white",
  deep_ocean_text_white_bg: "bg-white text-cs-900",
  deep_ocean_text_transparent_bg: "bg-transparent text-cs-900",

  common:
    "border-[0.5px] border-cs-700 shadow text-[12px] text-cs-700 font-[400] disabled:opacity-30 disabled:cursor-not-allowed",
  common_border: "border-[0.5px] border-cs-700",
  common_text: "text-[14px] text-cs-700",
} as const;

export const INPUT_SIZES = {
  "": "",
  xs: "w-fit max-w-40 sm:w-40",
  sm: "w-fit max-w-52 sm:w-52",
  md: "w-fit max-w-72 sm:w-72",
  lg: "w-fit max-w-96 sm:w-96",
  fit: "w-fit",
  full: "min-w-max w-full",
} as const;

export const TOASTER_IDS = {
  MAIN: "main-toaster",
  STORY_ACTIONS: "story-actions-toaster",
} as const;

export const MODAL_IDS = {
  PAGE_MODAL: "cs-page-modal",
  ACTIONS_MODAL: "cs-actions-modal",
};

export const ALLOWED_LIMITS = {
  "10": "10",
  "15": "15",
  "20": "20",
  "25": "25",
  "30": "30",
  "50": "50",
  "100": "100",
} as const;

export const FIXED_SEARCH_PARAMS = {
  MODAL_STATE: "modal_state", // values: OPEN, CLOSED
  SHOULD_REFRESH: "should_refresh", // values: true, false
} as const;

export const SUBTYPE_OPTIONS = [SUBTYPES.NEWS, SUBTYPES.RESEARCH].map(
  (item) => ({
    _id: item.ID,
    slug: item.SLUG,
    label: item.NAME,
    groupKey: "Subtypes",
  }),
);

export const TEAM_OPTIONS = [
  TEAMS.NEWSROOM,
  TEAMS.RESEARCH,
  TEAMS.BUSINESS,
].map((team) => ({
  _id: team.SLUG,
  label: team.NAME,
  slug: team.SLUG,
  groupKey: "Team",
}));

export const POST_SET_VALUE_OPTIONS = {
  shouldValidate: true,
  shouldDirty: true,
  shouldTouch: true,
};

export const SEARCH_PARAMS_OPTIONS: NavigateOptions = {
  replace: true,
};

export const BROWSER_EVENTS = {
  UNAUTHORIZED: "cs-event:unauthorized",
  CLOSE_MODAL: "cs-event:close-modal",
} as const;

export const QUERY_KEYS = {
  ROLES_LOOKUPS: "rolesLookupsQuery",
  VERTICALS_LOOKUPS: "verticalsLookupsQuery",
  AUTHORS_LOOKUPS: "authorsLookupsQuery",
  SUBTYPES_LOOKUPS: "subtypesLookupsQuery",
};
